import React from "react";
import { Typography, Card, CardContent, Grid } from '@mui/material';
import { format } from "date-fns";
import { Link } from 'react-router-dom';

import "./PlayerRankMockCard.css"

function PlayerRankMockCard({ playerRankMock }) {
    var date = new Date(playerRankMock.creation_date);
    var formattedDate = format(date, "MMM do, yyyy");
    const isMock = playerRankMock.rank_type === "mock_draft";

    return (
        <Card className="player-rank-mock-card">
            <CardContent className="player-rank-mock-card-content">
                <div className="player-rank-mock-card-rank-box">
                    <Typography component="div" className="player-rank-title">
                        {isMock ? "PICK" : "RANK"}
                    </Typography>
                    <Typography component="div" className="player-rank-value">
                        {playerRankMock.rank}
                    </Typography>
                </div>

                <div className="player-rank-mock-card-description">
                    <div className="player-rank-mock-header">
                        <Link to={(isMock ? "../mock-draft/" : "../ranking/") + playerRankMock.data_point_id}>
                            {playerRankMock.title}
                        </Link>
                    </div>
                    <div className="player-rank-mock-subheader">
                        <span className={`rank-type-badge ${isMock ? "mock" : "ranking"}`}>
                            {isMock ? "Mock Draft" : "Ranking"}
                        </span>
                        <div className="sub-heading-divider" />
                        <Typography component="p">{formattedDate}</Typography>
                        <div className="sub-heading-divider" />
                        <Link to={"../media-rankings?scouts_id=" + playerRankMock.scouts_id}>
                            {playerRankMock.scout_name}
                        </Link>
                        <div className="sub-heading-divider" />
                        <Link to={"../media-rankings?publication_id=" + playerRankMock.publication_id}>
                            {playerRankMock.publication_name}
                        </Link>
                    </div>
                </div>
            </CardContent>
            <div className="player-rank-mock-card-divider" />
        </Card>
    );
};

export default PlayerRankMockCard;
